import { render, staticRenderFns } from "./WaysOfLearning.vue?vue&type=template&id=a72ed29e&scoped=true&"
import script from "./WaysOfLearning.vue?vue&type=script&lang=js&"
export * from "./WaysOfLearning.vue?vue&type=script&lang=js&"
import style0 from "./WaysOfLearning.vue?vue&type=style&index=0&id=a72ed29e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72ed29e",
  null
  
)

export default component.exports